"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupButtonHover = setupButtonHover;
exports.setupPurchaseButtonHover = setupPurchaseButtonHover;
const button_arrow_black_png_1 = __importDefault(require("../img/button/button_arrow_black.png"));
const button_arrow_red_png_1 = __importDefault(require("../img/button/button_arrow_red.png"));
const trailer_btn_png_1 = __importDefault(require("../img/home/trailer_btn.png"));
const trailer_btn_white_png_1 = __importDefault(require("../img/home/trailer_btn_white.png"));
const icon_lang_png_1 = __importDefault(require("../img/nav/icon_lang.png"));
const icon_lang_red_png_1 = __importDefault(require("../img/nav/icon_lang_red.png"));
const icon_png_1 = __importDefault(require("../img/nav/icon.png"));
const icon_white_png_1 = __importDefault(require("../img/nav/icon_white.png"));
function setupButtonHover() {
    const btns = document.querySelectorAll('.btn');
    const trailerBtn = document.querySelector('.trailer__play__button');
    const globeBtn = document.querySelector('.eflags__globe');
    const logo = document.querySelector('.navigation__icon__transform');
    const videoImages = document.querySelectorAll('.imagegroup__item');
    // these are the small arrows on the buttons
    btns.forEach(btn => {
        const arrow = btn.querySelector('.btn__arrow');
        const isInactive = btn.classList.contains('btn--inactive');
        let currentlyActive = btn.classList.contains('btn--active');
        if (!arrow || isInactive)
            return;
        // btn.addEventListener('mouseenter', () => {
        //   currentlyActive = btn.classList.contains('btn--active');
        //   if (!currentlyActive) {
        //     arrow.src = redArrow;
        //   }
        // });
        // btn.addEventListener('mouseleave', () => {
        //   currentlyActive = btn.classList.contains('btn--active');
        //   if (!currentlyActive) {
        //     arrow.src = blackArrow;
        //   }
        // });
        if (!isInactive && currentlyActive) {
            arrow.src = button_arrow_red_png_1.default;
            return;
        }
    });
    // this is the large arrow on the home page arrow
    trailerBtn?.addEventListener('mouseenter', function () {
        this.src = trailer_btn_white_png_1.default;
    });
    trailerBtn?.addEventListener('mouseleave', function () {
        this.src = trailer_btn_png_1.default;
    });
    // this is the globe in top right corner.
    globeBtn?.addEventListener('mouseenter', function () {
        this.src = icon_lang_red_png_1.default;
    });
    globeBtn?.addEventListener('mouseleave', function () {
        this.src = icon_lang_png_1.default;
    });
    const homePage = document.querySelector('.home');
    // this is the small logo
    logo?.addEventListener('mouseenter', function () {
        if (homePage)
            return;
        this.src = icon_white_png_1.default;
    });
    logo?.addEventListener('mouseleave', function () {
        if (homePage)
            return;
        this.src = icon_png_1.default;
    });
    // these are the large arrows on the trailer page
    videoImages.forEach(trailer => {
        const arrow = trailer.querySelector('.imagegroup__playbutton');
        console.log(arrow);
        if (!arrow)
            return;
        trailer.addEventListener('mouseenter', () => {
            arrow.src = trailer_btn_white_png_1.default;
        });
        trailer.addEventListener('mouseleave', () => {
            arrow.src = trailer_btn_png_1.default;
        });
    });
}
// used in purchase section because buttons are replaced dynamically and need to be updated when created.
function setupPurchaseButtonHover() {
    const btns = document.querySelectorAll('.btn');
    btns.forEach(btn => {
        const arrow = btn.querySelector('.btn__arrow');
        if (!arrow)
            return;
        btn.addEventListener('mouseenter', () => {
            arrow.src = button_arrow_black_png_1.default;
        });
        btn.addEventListener('mouseleave', () => {
            arrow.src = button_arrow_black_png_1.default;
        });
    });
}
